<script setup>
import { ref } from 'vue';

const logoImg = ref(global.theme?.logo);
</script>

<template>
  <img
    :src="logoImg"
    alt="logo"
    class="primary-logo"
  >
</template>

<style lang="scss">
.primary-logo{
  width: 185px;
  object-fit: contain;
  max-height: var(--primary-logo-height);
}
</style>
